import { z } from 'zod';
import { BaseResponseSchema, containerSizeSchema, containerSlotSchema, containerTypeSchema, integerIdSchema, waferPatternTypeSchema, waferStatusSchema, } from './primitives.js';
/** Compact wafer row embedded in container slot map responses. */
export const WaferSummarySchema = z.object({
    id: integerIdSchema,
    type: waferPatternTypeSchema,
    layerName: z.string().min(1).max(100),
    companyAlias: z.string().min(1).max(100),
    status: waferStatusSchema,
    slotNumber: containerSlotSchema.optional(),
});
export const WaferSlotInfoSchema = z.object({
    slotNumber: containerSlotSchema,
    isEmpty: z.boolean(),
    wafer: WaferSummarySchema.optional(),
});
export const ContainerSlotMapSchema = z.object({
    containerId: integerIdSchema,
    containerType: containerTypeSchema,
    containerSize: containerSizeSchema,
    maxSlots: containerSlotSchema,
    slots: z.array(WaferSlotInfoSchema),
});
export const ContainerSlotsResponseSchema = BaseResponseSchema.extend({
    data: ContainerSlotMapSchema,
});
//# sourceMappingURL=container-slot-map.schemas.js.map